var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.942,
    height: 15.942,
    viewBox: "0 0 15.942 15.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23346",
    "data-name": "Group 23346",
    transform: "translate(-759 -142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002-exclamation",
    "data-name": "002-exclamation",
    transform: "translate(760 142.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23322",
    "data-name": "Group 23322",
    transform: "translate(-1 -0.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23321",
    "data-name": "Group 23321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M12.608,1.335a7.971,7.971,0,1,0,0,11.273A7.971,7.971,0,0,0,12.608,1.335Zm-.939,10.333a6.642,6.642,0,1,1,0-9.394A6.642,6.642,0,0,1,11.668,11.668Z",
    transform: "translate(1 1)",
    fill: "#77b448"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_002-tick",
    "data-name": "002-tick",
    transform: "translate(763.372 79.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23302",
    "data-name": "Group 23302",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M7.245,68.105a.368.368,0,0,0-.52,0L2.32,72.51.627,70.817a.368.368,0,0,0-.52.52L2.06,73.29a.368.368,0,0,0,.52,0l4.665-4.665A.368.368,0,0,0,7.245,68.105Z",
    transform: "translate(0 -67.997)",
    fill: "#77b448",
    stroke: "#77b448",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkSuccess);
export default __webpack_public_path__ + "static/media/mark_success.8e46d9d0371cb9f4aa4c91e30f74bf0e.svg";
export { ForwardRef as ReactComponent };